<div *ngIf="withModal" [ngClass]="{'cell-editable': !data.is_edited, 'cell-edited': data.is_edited}" class=" default-cell" (click)="data.cell_type === 'cella_edit_manuale' ? openCellManualEdit() : openCellManualEditWithMemory()">
  {{data.value | truncate : data.nDecimals }}
  <span class="show text-accent">(edit)</span>
</div>

<div *ngIf="!withModal" class=" default-cell"  [ngClass]="{'cell-editable': !data.is_edited, 'cell-edited': data.is_edited}">
    <input 
    class="form-control"
    type="text"
    placeholder="Insert value"
           (focus)="saveValue()" (blur)="processChange()"
           [(ngModel)]="data.value"
    ngbAutofocus>
</div>
